<script setup lang="ts">
defineProps<{
  small?: boolean
}>()
</script>

<template>
  <UBadge :size="small ? 'sm' : 'md'" variant="filled">
    Gratis<span class="sr-only">.</span>
  </UBadge>
</template>
